import { HTTP_STATUS, PROCESSED_NOTIFICATION_KINDS } from 'cpool-constants';
import { getActiveOrFirstUserId } from 'cpool-utils';
import { useTranslation } from 'react-i18next';

import { NotificationItemRow } from './NotificationItemRow';
import { NotificationRowError } from './NotificationRowError';
import { NotificationRowSkeleton } from './NotificationRowSkeleton';
import { APIError } from '~/api/APICommunicator';
import { useUserDisplayName } from '~/components/Dialogs/hooks/useUserDisplayName';
import useLead from '~/features/leadDetails/hooks/useLead';
import { getNotificationLinkOptions } from '~/features/notifications/utils/getNotificationLinkOptions';

type Props = {
    loanRequestId: string;
    processedAt: number;
    onNavigate?: () => void;
};

export const ProcessedAddedAdvisorRow: React.FC<Props> = ({ loanRequestId, onNavigate, processedAt }) => {
    const { t } = useTranslation();
    const lead = useLead(loanRequestId);
    const ownerName = useUserDisplayName(lead.data ? getActiveOrFirstUserId(lead.data) ?? undefined : undefined);

    if (lead.isLoading) return <NotificationRowSkeleton />;
    // after the share ended the advisor can no longer read the lead (403): nothing to link to
    if (lead.error instanceof APIError && lead.error.status === HTTP_STATUS.FORBIDDEN) return null;
    if (lead.isError) return <NotificationRowError />;
    if (!lead.data?.antragsteller1) return null;

    return (
        <NotificationItemRow
            previewName={`${lead.data.antragsteller1.personendaten?.vorname ?? ''} ${
                lead.data.antragsteller1.personendaten?.nachname ?? ''
            }`.trim()}
            previewDetail={ownerName ? t('TOP_HEADER.NOTIFICATIONS.ADDED_BY', { name: ownerName }) : ''}
            timestamp={processedAt}
            link={getNotificationLinkOptions(PROCESSED_NOTIFICATION_KINDS.ASSIGNED_USER_ADDED, loanRequestId)}
            onNavigate={onNavigate}
        />
    );
};
